import React, { useEffect, useState } from "react";
import { Table, DatePicker, Spin, Space } from "antd";
import { useReportApi } from "../../store/reportContext";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import PageNavigation from "../Layout/PageNavigation";
import ExcelExportButton from "./ExcelExportButton";

const { RangePicker } = DatePicker;

const TopSuppliersTable: React.FC = () => {
    const { fetchTopSuppliers } = useReportApi();
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [dateRange, setDateRange] = useState<[any, any]>([dayjs().startOf('month'), dayjs()]);

    useEffect(() => {
        setLoading(true);
        fetchTopSuppliers({
            startDate: dateRange[0].toISOString(),
            endDate: dateRange[1].toISOString(),
            limit: 10,
        }).then(res => {
            setData(res);
            setLoading(false);
        });
    }, [dateRange, fetchTopSuppliers]);

    const columns = [
        { title: t('supplier'), dataIndex: ['supplier', 'name'] },
        { title: t('qty'), dataIndex: 'transactions' },
        { title: t('totalAmount'), dataIndex: 'totalSupplied' }
    ];

    return (
        <>
            <PageNavigation title={t('top_suppliers') as string} />
            <Space style={{ marginBottom: 8 }} wrap>
                <RangePicker
                    value={dateRange}
                    onChange={dates => {
                        if (dates && dates[0] && dates[1]) setDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs]);
                    }}
                />
                <ExcelExportButton
                    fileName="top-suppliers"
                    sheetName={t('top_suppliers') as string}
                    columns={[
                        { header: t('supplier') as string, key: (row: any) => row.supplier?.name || '-', width: 28 },
                        { header: t('qty') as string, key: 'transactions', width: 12 },
                        {
                            header: t('totalAmount') as string,
                            key: (row: any) =>
                                (row.totalsByCurrency || [])
                                    .map((c: any) => `${c.currency} ${Number(c.amount).toLocaleString()}`)
                                    .join(' | ') || row.totalSupplied || 0,
                            width: 28,
                        },
                    ]}
                    rows={data}
                    title={[
                        t('top_suppliers') as string,
                        `${dateRange[0].format('YYYY-MM-DD')} → ${dateRange[1].format('YYYY-MM-DD')}`,
                    ]}
                />
            </Space>
            <Spin spinning={loading}>
                <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} />
            </Spin>
        </>
    );
};

export default TopSuppliersTable;
